//* 입력칸 아래 추천 목록 — 상주 말씀·장지 입력 공용 껍데기
//* 부모가 `relative` 여야 한다. 항목 선택은 mousedown(입력칸 blur 전에 값이 들어가야 목록이 먼저 안 닫힘)
import { FC } from 'react';

import { Link } from 'react-router-dom';

export interface SuggestionItem {
  key: string;
  text: string;
  //* 내 즐겨찾기(★ 표시)
  mine?: boolean;
}

interface Props {
  title: string;
  items: SuggestionItem[];
  onPick: (text: string) => void;
  manageTo?: string;
  manageLabel?: string;
  ariaLabel?: string;
  //* 목록 최대 높이(넘치면 스크롤). 기본은 제한 없음
  scrollClassName?: string;
}

export const SuggestionDropdown: FC<Props> = ({
  title,
  items,
  onPick,
  manageTo,
  manageLabel = '관리',
  ariaLabel,
  scrollClassName = '',
}) => {
  if (items.length === 0) return null;
  return (
    <div
      role="listbox"
      aria-label={ariaLabel ?? title}
      //* Toggle 라벨(relative z-10) 등 뒤따르는 요소 위로. 네비바(z-20)·팝업(z-30)보다는 아래
      className="absolute left-0 right-0 top-full z-[15] mt-1 overflow-hidden rounded-md border shadow-md theme-bg-1 theme-border-1"
    >
      <div className="flex items-center justify-between px-3 py-1.5 text-xs theme-text-8">
        <span className="font-bold">{title}</span>
        {manageTo && (
          <Link
            to={manageTo}
            onMouseDown={(e) => e.preventDefault()}
            className="underline"
          >
            {manageLabel}
          </Link>
        )}
      </div>
      <ul className={`divide-y divide-gray-100 ${scrollClassName}`}>
        {items.map((s) => (
          <li key={s.key}>
            <button
              type="button"
              role="option"
              aria-selected={false}
              onMouseDown={(e) => {
                e.preventDefault();
                onPick(s.text);
              }}
              className="w-full break-keep px-3 py-2 text-left text-xs font-medium leading-5 theme-text-1 active:bg-gray-100"
            >
              {s.mine && <span className="mr-1 font-bold theme-text-main">★</span>}
              {s.text}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
